import axios from "axios";
import { responseHandler } from "../utils/responseHandler";

// const API_BASE_URL = "https://warehouse.innoventixsolutions.in/api/"; // Your API URL
const API_BASE_URL = "https://admin.beawms.com/api/"; // Your API URL

// Create Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// export const adminLogin1 = async () => {
//   try {
//     const response = await api.get("admin/login");
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching:", error);
//     throw error;
//   }
// };

export const sampleData = async () => {
  try {
    let response = {};
    response.status = 401;
    return await responseHandler(response);
  } catch (error) {
    console.error("Error Login:", error);
    throw error;
  }
};

// Authentication API's
export const adminLogin = async (postData) => {
  try {
    const response = await api.post("user/login", postData);
    return response.data;
  } catch (error) {
    console.error("Error Login:", error);
    throw error;
  }
};

export const adminForgotPass = async (postData) => {
  try {
    const response = await api.post("user/forgot-password", postData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const adminOtpVerify = async (postData) => {
  try {
    const response = await api.post("user/verify-otp", postData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const adminNewPass = async (postData) => {
  try {
    const response = await api.post("user/reset-password", postData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Dashboard report API
export const getUserReport = async (data) => {
  try {
    const response = await api.get(`user/user-report`, data);
    return response.data;
  } catch (error) {
    console.error("Error getting company report:", error);
    throw error;
  }
};

// Product API's
export const productList = async (params) => {
  try {
    const response = await api.get("admin/list-all-products", {
      params: {
        ...params,
        sort: "id",
        sort_order: "desc",
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createProduct = async (formData) => {
  try {
    const response = await api.post("admin/create-product", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating product:", error);
    throw error;
  }
};

export const updateProduct = async (formData) => {
  try {
    const response = await api.post(`admin/update-product`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

    return response.data;
  } catch (error) {
    console.error("Error updating product:", error);
    throw error;
  }
};

// export const updateProduct = async (formData) => {
//   try {
//     const response = await axios.post('/api/update-product', formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const getProductDetailsById = async (productId) => {
  try {
    const response = await api.get(`admin/get-product-by-id/${productId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const productTransaction = async (transaction_id) => {
  try {
    const response = await api.get(`admin/list-products/${transaction_id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const updateProductQuantity = async (data) => {
  try {
    const response = await api.post("admin/update-products-quantity", data);
    return response.data;
  } catch (error) {
    console.error("Error updating product quantity:", error);
    throw error;
  }
};

export const getProductByBarcodeNumber = async (barcode) => {
  try {
    const response = await api.get(`admin/get-product-by-barcode/${barcode}`);
    return response.data;
  }
  catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const productsOutbound = async () => {
  try {
    const response = await api.post("admin/outbound-product");
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const pastTransaction = async (params) => {
  try {
    const response = await api.get("user/list-transaction-history", {
      params: {
        ...params,
        sort: "id",
        sort_order: "desc",
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

// Logistic API's
export const logisticList = async (params) => {
  try {
    const response = await api.get("admin/list-logistics", {
      params: {
        ...params,
        sort: 'id',
        sort_order: 'desc',
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const createLogistic = async (data) => {
  try {
    const response = await api.post("admin/create-logistics", data);
    return response;
  } catch (error) {
    console.error("Error creating logistic:", error);
    throw error;
  }
};


export const getLogisticById = async (id) => {
  try {
    const response = await api.get(`admin/get-logistics/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateLogistic = async (data) => {
  try {
    const response = await api.post(`admin/update-logistics`, data);
    return response;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

// ProductTransaction API's
export const productTransactionHistoryList = async (userId, params) => {
  try {
    const response = await api.get(`user/list-transaction-history/${userId}`, {
      params: {
        ...params,
        sort: "id",
        sort_order: "desc",
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching transaction history:", error);
    throw error;
  }
};

// Warehouse API's
export const warehouseList = async (params) => {
  try {
    const response = await api.get("admin/list-warehouse", {
      params: {
        ...params,
        sort_by: 'id',
        sort_order: 'desc'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const createWarehouse = async (data) => {
  try {
    const response = await api.post("admin/create-warehouse", data);
    return response.data;
  } catch (error) {
    console.error("Error creating warehouse:", error);
    throw error;
  }
};

export const getWarehouseById = async (id) => {
  try {
    const response = await api.get(`admin/warehouse/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateWarehouse = async (data) => {
  try {
    const response = await api.post("admin/update-warehouse", data);
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const getCountries = async () => {
  try {
    const response = await api.get('option/list-country');
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStates = async (countryId) => {
  try {
    // const response = await api.get(`option/list-state/${countryId}`);
    const response = await api.get(`option/list-state`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCities = async (stateId) => {
  try {
    // const response = await api.get(`option/list-city/${stateId}`);
    const response = await api.get(`option/list-city`);
    return response;
  } catch (error) {
    throw error;
  }
};


// Company API's
// export const companyList = async (params) => {
//   try {
//     const response = await api.get("admin/list-company", { 
//       params: {
//         sort: 'id',
//         sort_order: 'desc',
//         company_name: params.company_name || '',
//         from_date: params.from_date || '',
//         to_date: params.to_date || '',
//         status: params.status || '',
//         page: params.page || '1',
//         limit: params.limit || '10'
//     }
//   });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching:", error);
//     throw error;
//   }
// };

export const companyList = async (params) => {
  try {
    // Prepare parameters conditionally
    const response = await api.get("admin/list-company", {
      params: {
        sort: 'id',
        sort_order: 'desc',
        ...(params.page && { page: params.page }),
        ...(params.paginate_per_page && { paginate_per_page: params.paginate_per_page }),
        ...(params.from && { from: params.from }),
        ...(params.to && { to: params.to }),
        ...(params.status && { status: params.status }),
        ...(params.company_name && { company_name: params.company_name }),
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const allCompanyList = async (params) => { // this api for show company list in every dropdown
  try {
    const response = await api.get("admin/list-all-company", {
      params: {
        sort: 'id',
        sort_order: 'desc',
        company_name: params.company_name || '',
        from_date: params.from_date || '',
        to_date: params.to_date || '',
        status: params.status || '',
        page: params.page || '1',
        limit: params.limit || '10'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const createCompany = async (data) => {
  try {
    const response = await api.post("admin/create-company", data);
    return response.data;
  } catch (error) {
    console.error("Error creating company:", error);
    throw error;
  }
};

export const getCompanyById = async (id) => {
  try {
    const response = await api.get(`admin/company/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCompany = async (data) => {
  try {
    const response = await api.post(`admin/update-company`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating company:", error);
    throw error;
  }
};

// Company-Warehouse API's
export const createCompanyWarehouse = async (data) => {
  try {
    const response = await api.post("admin/create-company-warehouse", data);
    return response.data;
  } catch (error) {
    console.error("Error creating company warehouse:", error);
    throw error;
  }
};

export const getCompanyWarehouseById = async (id) => {
  try {
    const response = await api.get(`admin/list-company-warehouse/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyWarehouse = async (data) => {
  try {
    const response = await api.post(`admin/update-company-warehouse`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating company warehouse:", error);
    throw error;
  }
};